import React from "react";
import { useHistory } from "react-router-dom";
import { useTheme } from "emotion-theming";

import { BottomFixed } from "components/Buttons/BottomFixed";
import { FilledButton } from "@nykaa/payment-ui/src/Button";

import { trackProceedToPayClick } from "layouts/Payment/common/dependencies/tracking";
import { doAppendQueryParam } from "../../../../../helpers/index";
import { doRedirect } from "helpers/utils/redirection";


interface PlaceOrderButtonProps {
  proceedToPayText: string;
  disabled: boolean;
  orderAmount: number;
  isFullPaymentByGiftCard: boolean;
  onSubmit: () => void;
  dataTestId?: string;
}

/**
 * @description
 * component that displays button on saved payment page
 * button text is passed as props
 * places COD order when grandtotal = 0
 * @param  proceedToPayText text on button component
 * disabled should be disabled incase of disabled
 * @returns
 * button component
 */
export const PlaceOrderButton = ({
  proceedToPayText,
  disabled,
  orderAmount,
  isFullPaymentByGiftCard,
  onSubmit,
  dataTestId,
}: PlaceOrderButtonProps) => {
  const history = useHistory();
  const theme = useTheme() as Theme;

  /**
   * places cod order incase of not full gc and grandTotal = 0
   * redirects user to all payment screens in other cases
   */
  const handleSubmit = () => {
    if (!isFullPaymentByGiftCard && orderAmount <= 0) {
      onSubmit();
    } else {
      let url = doAppendQueryParam("screen", "newPayment");
      trackProceedToPayClick();

      doRedirect({
        url,
        history,
        isClientRedirection: true,
      });
    }
  };

  return (
    <BottomFixed className="ptb16 prl20" style={{ background: "white" }}>
      <FilledButton
        text={proceedToPayText}
        font={theme.typography.buttonLarge}
        color={theme.colors.surface}
        onClick={handleSubmit}
        isDisabled={disabled}
        dataTestId={dataTestId}
        theme={theme}
      />
    </BottomFixed>
  );
};
